import RosterItemWithSummarizedBookings from './RosterItemWithSummarizedBookings';

export default class RosterUnavailability extends RosterItemWithSummarizedBookings {
  constructor(start, end, hasActuals, reason) {
    super('unavailability', start, end, hasActuals);
    this.reason = reason;
  }

  canBeMerged(unavailability) {
    super.canBeMerged(unavailability) && unavailability.reason === this.reason;
  }
}
